<template>
  <div>
    <reservation-form
      @save="createReservation"
      @cancel="cancelCreateReservation"
      v-loading.fullscreen.lock="fullscreenLoading"
      :reservation="reservation"
      :line="line"
      type="create" />

    <!-- Cancel Create Dialog -->
    <el-dialog :visible.sync="control.showCancelCreateDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการลงข้อมูล ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleCancel(false)">ไม่</el-button>
        <el-button type="primary" @click="handleCancel(true)" class="edit">ยกเลิก</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PatientModel from '@/model/PatientModel'
import ReservationForm from '@/components/reservation/ReservationForm'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'ReservationCreate',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      reservation: {},
      customer: {},
      line: '',
      control: {
        showCancelCreateDialog: false,
      },
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.prepareCreateReservation()
  },
  components: {
    ReservationForm,
  },
  methods: {
    async prepareCreateReservation () {
      try {
        this.fullscreenLoading = true
        this.reservation = await this.$api.Reservation.preparecreate(this.id, 'caregiver')
        this.reservation.canEditDaysOff = true
        this.getLineID()
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    cancelCreateReservation () {
      this.control.showCancelCreateDialog = true
    },
    handleCancel (status) {
      if (status) {
        this.$router.push({ name: 'PatientDetail', params: { id: this.id }, query: { tab: 'workcalendarTab' } })
      }
      this.control.showCancelCreateDialog = false
    },
    async createReservation (form) {
      const value = JSON.parse(JSON.stringify(form))
      try {
        this.fullscreenLoading = true
        value.reservation.patientId = this.id
        switch (value.reservation.price.discount.type) {
          case 'code':
            value.reservation.price.discount = null
            break
          case 'no':
            value.reservation.price.discount = null
            value.reservation.promotionCode = ''
            break
          default:
            value.reservation.price.discount.value = Number(value.reservation.price.discount.value)
            value.reservation.promotionCode = ''
        }
        await this.$api.Reservation.create(value.reservation)
        this.showSuccessDialog({ name: 'PatientDetail', params: { id: this.id }, query: { tab: 'workcalendarTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    async getLineID () {
      try {
        const raw = await this.$api.Patient.get(this.id)
        this.customer = PatientModel.fromJSON(raw).transformToDisplayable()
        this.line = this.customer.lineId
        this.reservation.customerType = raw.customerType
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
  },
}
</script>
